import { useEffect, useState } from "react";
import { api, mediaUrl } from "@/lib/api";
import { SEO } from "@/components/SEO";
import { PageHero, Loading, VerifyBadge } from "@/components/shared";

export default function Staff() {
  const [staff, setStaff] = useState(null);
  useEffect(() => { api.get("/public/staff").then((r) => setStaff(r.data)); }, []);
  const initials = (n) => n.split(" ").map((x) => x[0]).slice(0, 2).join("");

  return (
    <>
      <SEO title="Our Staff | Brackenfell Junior Rugby Club" description="Meet the committee and management team behind Brackenfell Junior Rugby Club." />
      <PageHero title="Our Staff" subtitle="The people who keep the club running and our players supported." />
      <section className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8">
        {staff === null ? <Loading /> : (
          <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
            {staff.map((s) => (
              <div key={s.id} className="overflow-hidden rounded-2xl border border-slate-200 bg-white text-center shadow-sm transition-all hover:-translate-y-1 hover:shadow-lg" data-testid={`staff-card-${s.id}`}>
                <div className="aspect-[3/4] bg-gradient-to-b from-[#0B2A4A] to-[#1E63D6]">
                  {s.photo_url ? <img src={mediaUrl(s.photo_url)} alt={s.name} className="h-full w-full object-cover object-top" /> : (
                    <div className="flex h-full items-center justify-center font-heading text-5xl font-black text-white/25">{initials(s.name)}</div>
                  )}
                </div>
                <div className="p-5">
                  <h3 className="font-heading text-lg font-bold uppercase text-[#0B2A4A]">{s.name}</h3>
                  <p className="text-sm font-semibold text-[#1E63D6]">{s.role}</p>
                  {s.description && <p className="mt-2 text-sm text-slate-600">{s.description}</p>}
                  {s.migration_status !== "verified" && <div className="mt-2"><VerifyBadge /></div>}
                </div>
              </div>
            ))}
          </div>
        )}
      </section>
    </>
  );
}
